import { Enums, Events } from "../../thor.enums";
import { Membership } from "../../typings/organization";
import { thor } from "../../typings/thor";

export class FilterOrganizationController {
    public static $inject: string[] = ["$log", "$rootScope", "$scope", "$translate", "searchService", "toaster"];

    // binded
    public organization: string;
    public membership: Membership;

    public organizations: thor.Organization[];
    public selectedOrganizations: thor.Organization[];
    public isLoading: boolean;
    public searchTerm: string;

    private $t;

    constructor(
        private $log: ng.ILogService,
        private $rootScope: ng.IRootScopeService,
        private $scope: ng.IScope,
        $translate: ng.translate.ITranslateService,
        private searchService,
        private toaster
    ) {
        this.$t = $translate.instant;
    }

    public $onInit() {
        this.isLoading = true;
        this.selectedOrganizations = [];

        const filterParams = { authorized_site: `contains:${Enums.Site.Interencheres}` };

        this.searchService
            .getOrganizations(filterParams)
            .then(result => {
                this.organizations = result.items;
                this.isLoading = false;
            })
            .catch(error => {
                this.$log.error("Error while getting all organizations", error);
                this.toaster.show(this.$t("impossible_de_recuperer_la_liste_des_etudes"), true);
            });

        this.$scope.$watch(
            () => this.selectedOrganizations,
            () => {
                if (this.selectedOrganizations.length) {
                    this.organization = this.selectedOrganizations.map(orga => orga.id).join(",");
                }
                this.$rootScope.$emit(
                    Events.OrganizationFilterUpdated,
                    Array.from(new Set(this.selectedOrganizations.map(orga => orga.authorized_sites).flat()))
                );
            }
        );

        this.$scope.$watch(
            () => this.organization,
            () => {
                if (!this.organization) {
                    this.selectedOrganizations = [];
                }
            }
        );
    }

    public clearSearchTerm() {
        this.searchTerm = "";
    }

    public removeSelected(organization) {
        this.selectedOrganizations = this.selectedOrganizations.filter(orga => orga !== organization);
    }
}
